const FIXED_ART_BUNDLE_HANDLES = Object.freeze([
  'two-tees',
  'sun-moon',
  'crystal-veil-moon',
  'black-halo-moon',
  'dead-stars-afterlight',
]);

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideIrrelevantBirthFields, { once: true });
  } else {
    hideIrrelevantBirthFields();
  }
}

function hideIrrelevantBirthFields() {
  const handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  scrubFixedArtSurfaces({
    handle,
    blocks: document.querySelectorAll('product-custom-property-component'),
    intros: document.querySelectorAll('rte-formatter'),
    gates: document.querySelectorAll('birth-data-gate'),
    previews: document.querySelectorAll('chart-preview, .stz-preview, [data-chart-preview]'),
  });
}

function isFixedArtBundleHandle(handle) {
  return FIXED_ART_BUNDLE_HANDLES.includes(String(handle || ''));
}

function disableAndHide(block) {
  for (const field of block.querySelectorAll('input, textarea, select')) {
    field.required = false;
    field.disabled = true;
    field.removeAttribute('required');
    field.removeAttribute('aria-required');
    field.removeAttribute('name');
  }

  block.hidden = true;
}

function scrubFixedArtSurfaces({ handle, blocks = [], intros = [], gates = [], previews = [] } = {}) {
  if (!isFixedArtBundleHandle(handle)) return false;

  for (const block of blocks) disableAndHide(block);
  for (const intro of intros) {
    if (intro.textContent?.toLowerCase().includes('birth details')) intro.hidden = true;
  }
  for (const gate of gates) gate.hidden = true;
  for (const preview of previews) {
    preview.hidden = true;
    preview.setAttribute('aria-hidden', 'true');
  }
  return true;
}

globalThis.StarlyzedFixedBirthDefense = {
  FIXED_ART_BUNDLE_HANDLES,
  isFixedArtBundleHandle,
  scrubFixedArtSurfaces,
};
